import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import APIs from "../../APIs";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../redux/authSlice";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { toast } from "react-toastify";
import * as bootstrap from "bootstrap";
import { setAddresses, setPickupAddress, setDropoffAddress } from "../../redux/addressSlice";
import Select from "react-select";
import { jwtDecode } from "jwt-decode";
import { useGoogleLogin } from "@react-oauth/google";
import { GoogleMap, Marker, useLoadScript, Polyline  } from "@react-google-maps/api";
import GoogleAddressAutocomplete from "../../components/GoogleAddressAutocomplete";
import { GOOGLE_MAP_KEY } from "../../Utils/Utils";
import { useMyLocation } from "../../hooks/LocationContext";
const libraries = ["places"];
const mapContainerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "15px",
};
//const centerDefault = { lat: 20.5937, lng: 78.9629 }; // Default center: India

const Step2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { location: currentLocation, loaded } = useMyLocation();
  const centerDefault = { lat: currentLocation.lat, lng: currentLocation.lng };

  const pickupAddress = useSelector((state) => state.address.pickupAddress);
  const dropoffAddress = useSelector((state) => state.address.dropoffAddress);
  const [pickup, setPickup] = useState(pickupAddress || null);
  const [dropoff, setDropoff] = useState(dropoffAddress || null);
  const [directions, setDirections] = useState(null);
  const [distance, setDistance] = useState(null);
  const inputref = useRef(null);
    const { isLoaded } = useLoadScript({
      // replace with env var / safer approach for real apps
      googleMapsApiKey: GOOGLE_MAP_KEY,
       libraries,
    });
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    full_name: "",
    mobile_number: "",
    user_type: "",
    address: "",
    landmark: "",
    country: "",
    state: "",
    city: "",
    zip_code: "",
    address_type: "",
  });
  const [message, setMessage] = useState("");
  const [toastData, setToastData] = useState(null);
  const [otpSource, setOtpSource] = useState(null);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // 6-digit OTP
  const inputsRef = useRef([]);
const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const userId = userData?.user_id;
  const [forgotEmail, setForgotEmail] = useState("");
  const [loadingForgot, setLoadingForgot] = useState(false);
  const [resetPassword, setResetPassword] = useState({ password: "", confirmPassword: "" });
  const [resetErrors, setResetErrors] = useState({});
  const [loadingReset, setLoadingReset] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [showPassword, setShowPassword] = useState({
  password: false,
  confirmPassword: false,
  });
  const [addresses, setAddressesState] = useState([]);
  const [errors, setErrors] = useState({});
  const [coordinates, setCoordinates] = useState({  lat: currentLocation.lat, lng: currentLocation.lng });
  const [map, setMap] = useState(null);
  const geocoderRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [modalType, setModalType] = useState(null); // "pickup" or "dropoff"
  const pickupLat = pickupAddress?.address_lat ? parseFloat(pickupAddress.address_lat) : null;
  const pickupLng = pickupAddress?.address_long ? parseFloat(pickupAddress.address_long) : null;
  const dropLat = dropoffAddress?.address_lat ? parseFloat(dropoffAddress.address_lat) : null;
  const dropLng = dropoffAddress?.address_long ? parseFloat(dropoffAddress.address_long) : null;
const [mapInstance, setMapInstance] = useState(null);
  const centerLat = pickupLat && dropLat ? (pickupLat + dropLat) / 2 : pickupLat || dropLat || 0;
  const centerLng = pickupLng && dropLng ? (pickupLng + dropLng) / 2 : pickupLng || dropLng || 0;
const [address, setAddress] = useState("");
  const mapCenter = (pickupLat && pickupLng) || (dropLat && dropLng)
    ? { lat: centerLat, lng: centerLng }
    : centerDefault;
    const [mapRef, setMapRef] = useState(null);
    
const [countryList, setCountryList] = useState([])
const [loading4, setLoading4] = useState(false);
const [selectedCode, setSelectedCode] = useState([])
const [autoKey, setAutoKey] = useState(0);
useEffect(() => {
  getCountryApi()
}, [])

useEffect(() => {
  if (countryList.length && !selectedCode) {
    setSelectedCode(countryList[0]);
  }
}, [countryList]);


const getCountryApi = async () => {
  setLoading4(true)
  try {
    const response = await APIs.post("user/getCountry", {});
    console.log("getCountryApi Response:", response.data.data[0]);

    if (response.data.status == "success") {
      setLoading4(false)
      setCountryList(response.data.data)
      setSelectedCode(response.data.data[0])
    } else {
      setLoading4(false)
      toast.error(response.data.message, { position: "top-right" });
    }
  } catch (error) {
    setLoading4(false)
    toast.error("Error getCountryApi", { position: "top-right" });
  } finally {
    setLoading4(false);
  }
};
  // Sync local pickup/dropoff with Redux store
  useEffect(() => setPickup(pickupAddress || null), [pickupAddress]);
  useEffect(() => setDropoff(dropoffAddress || null), [dropoffAddress]);
  useEffect(() => {
    if (addresses.length > 0) {
      if (!pickup && addresses[0]) {
        dispatch(setPickupAddress(addresses[0]));
      }
      if (!dropoff && addresses.length > 1) {
        dispatch(setDropoffAddress(addresses[1]));
      }
    }
  }, [addresses, pickup, dropoff, dispatch]);

  // Fetch user (if you need user details elsewhere)
  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return;
      try {
        const res = await APIs.post(
          "user/getUserById",
          { user_id: userId },
          { headers: { "Content-Type": "application/json" } }
        );
        // if you want to use user data later, set state here
        // setUser(res.data?.data || {});
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };
    fetchUser();
  }, [userId]);

  // Fetch addresses for user and store locally and in redux
  const getAddress = useCallback(async () => {
    if (!userId) {
      setAddressesState([]);
      dispatch(setAddresses([]));
      return;
    }
    try {
      // API expects user_id (consistent with other calls)
      const res = await APIs.post("address/getAddressByUser", { user_id: userId });
      const dataArray = Array.isArray(res.data.data) ? res.data.data : [];
      dispatch(setAddresses(dataArray));
      setAddressesState(dataArray);
    } catch (error) {
      console.error("Error fetching addresses:", error);
      dispatch(setAddresses([]));
      setAddressesState([]);
    }
  }, [userId, dispatch]);

  useEffect(() => {
    getAddress();
  }, [getAddress]);
  // 🟢 Handle map load
  const handleMapLoad = (map) => setMapInstance(map);

  // 🟢 Fetch address from coordinates when map is dragged
 const fetchAddress = async (lat, lng) => {
  const geocoder = new window.google.maps.Geocoder();
  const { results } = await geocoder.geocode({ location: { lat, lng } });

  if (results[0]) {
    const addressComponents = results[0].address_components || [];

    // Helper to safely get component by type
    const getComponent = (type) =>
      addressComponents.find((comp) => comp.types.includes(type))?.long_name || "";

    // Extract components in logical order
    const address = results[0].formatted_address;
    const landmark =
      getComponent("point_of_interest") ||
      getComponent("establishment") ||
      getComponent("premise") ||
      getComponent("subpremise") ||
      ""; // fallback empty if not available
    const city = getComponent("locality") || getComponent("administrative_area_level_2");
    const state = getComponent("administrative_area_level_1");
    const country = getComponent("country");
    const zip_code = getComponent("postal_code");

    // Update all in one structured flow
    setFormData((prev) => ({
      ...prev,
      address,
      landmark,
      city,
      state,
      country,
      zip_code,
    }));
  }
};

  // utility to get coordinates from address string using Geocode API
  async function getCoordinatesFromAddress(address) {
    try {
      const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || GOOGLE_MAP_KEY;
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`
      );
      const data = await response.json();
      if (data.status === "OK" && data.results && data.results[0]) {
        const { lat, lng } = data.results[0].geometry.location;
        return { lat, lng };
      } else {
        console.error("Geocode API Error:", data.status, data.error_message || "");
        toast.error("Unable to find location for this address");
        return { lat: 0, lng: 0 };
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      toast.error("Error fetching coordinates");
      return { lat: 0, lng: 0 };
    }
  }

  // validate add address form
  const validateForm = () => {
    setErrors({}); // clear any previous errors
    return true;  
    // const newErrors = {};
    // if (!formData.address || !formData.address.trim()) newErrors.address = "Address is required";
    // if (!formData.landmark || !formData.landmark.trim()) newErrors.landmark = "Landmark is required";
    // if (!formData.city || !formData.city.trim()) newErrors.city = "City is required";
    // if (!formData.state || !formData.state.trim()) newErrors.state = "State is required";
    // if (!formData.country || !formData.country.trim()) newErrors.country = "Country is required";
    // if (!formData.zip_code || !formData.zip_code.trim()) newErrors.zip_code = "Zip Code is required";
    // if (!formData.address_type || !formData.address_type.trim()) newErrors.address_type = "Address type is required";
    // setErrors(newErrors);
    // return Object.keys(newErrors).length === 0;
  };

 
  // submit add address form
  const handleAddressSubmit = async (e) => {
    e.preventDefault();

    if (!userId) {
      toast.error("User not logged in!");
      return;
    }
    const finalAddressType = formData.address_type || "Other";
    const zipCode = formData.zip_code || "0";
    const city = formData.city || "";
    if (!validateForm()) return;

    setLoading(true);

    try {
      const fullAddress = `${formData.address},${formData.landmark}, ${formData.city}, ${formData.state}, ${formData.country}, ${formData.zip_code}`;
      const { lat, lng } = await getCoordinatesFromAddress(fullAddress);

      const payload = {
        user_id: userId,
        address_lat: lat,
        address_long: lng,
        ...formData,
        address_type: finalAddressType,
        zip_code:zipCode,
        city: city,
      };

      const res = await APIs.post("address/addAddress", payload);

      if (res.data && res.data.status === "success") {
        toast.success("Address added successfully!");
        // window.location.reload();
        // Close modal
        const modal = bootstrap.Modal.getInstance(document.getElementById("addAddressModalToggle"));
        if (modal) modal.hide();

        // Re-fetch updated addresses
        const updatedRes = await APIs.post("address/getAddressByUser", { user_id: userId });
        const updatedAddresses = updatedRes.data.data || [];
        dispatch(setAddresses(updatedAddresses));
        setAddressesState(updatedAddresses);

        // Find the newly added address (by address or unique id if available)
        const newAddr = updatedAddresses.find((a) => a.address === formData.address);
        // const newAddr = updatedAddresses.length > 0 ? updatedAddresses[updatedAddresses.length - 1]: null;

        // ✅ Auto-select for pickup or dropoff based on modalType
        if (modalType === "pickup" && newAddr) {
          dispatch(setPickupAddress(newAddr));
        } else if (modalType === "dropoff" && newAddr) {
          dispatch(setDropoffAddress(newAddr));
        }

        // ✅ Reset form
        setFormData({
          address: "",
          landmark: "",
          country: "",
          state: "",
          city: "",
          zip_code: "",
          address_type: "",
        });
        setErrors({});
        setAutoKey((prev) => prev + 1);
      }else {
        toast.error(res.data?.message || "Failed to add address");
      }
    } catch (err) {
      console.error("Error adding address:", err);
      toast.error("Error adding address or fetching location");
    } finally {
      setLoading(false);
    }
  };

    // ✅ Save login email/password only
    useEffect(() => {
      sessionStorage.setItem(
        "loginFormData",
        JSON.stringify({ email: formData.email, password: formData.password })
      );
    }, [formData.email, formData.password]);
  
     // close modal helper (hides bootstrap modal instance)
  const handleCloseModal = (modalId) => {
    const modalEl = document.getElementById(modalId);
    if (!modalEl) return;
    const modalInstance = bootstrap.Modal.getInstance(modalEl) || new bootstrap.Modal(modalEl);
    modalInstance.hide();
    // reload page only if you truly need to refresh; prefer re-fetching data
    // Here we re-fetch addresses to update the selects without full reload
    setTimeout(() => {
      getAddress();
      modalInstance.hide(); // properly hides the modal
      window.location.reload();
    }, 300);
  };
   // continue button handler
  const handleContinue = () => {
    if (!pickup || !dropoff) {
      toast.error("Please select both pickup and drop-off addresses.", { position: "top-right" });
      return;
    }
    navigate("/Step3");
  };
    // Handle input change
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };
   { /* ------------------------------------------------ */ }
   const handleForgotPasswordSubmit = async (e) => {
      e.preventDefault();
    if (!forgotEmail) {
      toast.error("Please enter your email address", { position: "top-right"});
      return;
    }
      setLoadingForgot(true);
      setMessage("");
  
      try {
        const response = await APIs.post("user/forgotPassword", { email: forgotEmail }, {
          headers: { "Content-Type": "multipart/form-data" },
        });
  
        if (response.data.status === "success") {
          const userData = response.data.data;
          // dispatch(setUserData(userData));
          // sessionStorage.setItem("userData", JSON.stringify(userData));
          sessionStorage.setItem("pendingUser", JSON.stringify({ email:forgotEmail }));
          setOtpSource("forgot"); // ✅ important for back button
          setTimeout(() => {
            const loginEl = document.getElementById("ForgotPasswordModalToggle");
            if (loginEl) {
              const loginModal =
                window.bootstrap.Modal.getInstance(loginEl) ||
                new window.bootstrap.Modal(loginEl);
              loginModal.hide();
            }
  
            const otpEl = document.getElementById("OtpModalToggle");
            if (otpEl) {
              const otpModal = new window.bootstrap.Modal(otpEl);
              otpModal.show();
            }
          }, 1000);
        } else {
          toast.error(response.data.message || "failed.", { position: "top-right"});
        }
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Failed. Please try again.",{ position: "top-right"});
      } finally {
        setLoadingForgot(false);
      }
    };
    const validateResetPassword = () => {
    const newErrors = {};
    if (!resetPassword.password) newErrors.password = "Password is required";
    else if (resetPassword.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";
  
    if (!resetPassword.confirmPassword) newErrors.confirmPassword = "Confirm Password is required";
    else if (resetPassword.password !== resetPassword.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match";
  
    setResetErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setResetErrors(""); // optional top-level error
  
    if (!validateResetPassword()) return; // use per-field validation
  
    const storedUserData = JSON.parse(sessionStorage.getItem("userData"));
    const user_id = storedUserData?.user_id;
    if (!user_id) {
      setResetErrors("User not found.");
      return;
    }
  
    setLoadingReset(true);
    try {
      const response = await APIs.post("user/resetPassword", {
        user_id,
        password: resetPassword.password,
      });
  
      toast.success("Password reset successfully!", { position: "top-right" });
  
      const resetModalEl = document.getElementById("ResetPasswordModalToggle");
      const resetModal = window.bootstrap.Modal.getInstance(resetModalEl);
      resetModal.hide();
  
      const resetEl = document.getElementById("LoginModalToggle");
            if (resetEl) {
              const loginModal = new window.bootstrap.Modal(resetEl);
              loginModal.show();
            }
    } catch (error) {
      setResetErrors(error.response?.data?.message || "Failed to reset password");
    } finally {
      setLoadingReset(false);
    }
  };
    // Validate login form
    const validateLogin = () => {
      const newErrors = {};
      if (!formData.email) {
        newErrors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Enter a valid email";
      }
  
      if (!formData.password) {
        newErrors.password = "Password is required";
      } else if (formData.password.length < 6) {
        newErrors.password = "Password must be at least 6 characters";
      }
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
  
    // Validate signup form
    const validateSignup = () => {
      const newErrors = {};
      if (!formData.full_name) newErrors.full_name = "User Name is required";
      if (!formData.email) {
        newErrors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Enter a valid email";
      }
      if (!formData.mobile_number)
        newErrors.mobile_number = "Mobile number is required";
      if (!formData.user_type) newErrors.user_type = "User Type is required";
      if (!formData.password) {
        newErrors.password = "Password is required";
      } else if (formData.password.length < 6) {
        newErrors.password = "Password must be at least 6 characters";
      }
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
  
    // Login Submit
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!validateLogin()) return;
  
      setLoading(true);
      setMessage("");
  
      try {
        const response = await APIs.post("user/loginViaOTP", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
  
        if (response.data.status === "success") {
          const email = formData.email?.trim().toLowerCase();

          // ✅ Store only email temporarily until OTP verified
          sessionStorage.setItem("pendingUser", JSON.stringify({ email }));

          setToastData({
            title: "Login",
            message: response.data.message,
            type: "success",
            id: Date.now(),
          });
  
          setOtpSource("login"); // ✅ important for back button
          setTimeout(() => {
            const loginEl = document.getElementById("LoginModalToggle");
            if (loginEl) {
              const loginModal =
                window.bootstrap.Modal.getInstance(loginEl) ||
                new window.bootstrap.Modal(loginEl);
              loginModal.hide();
            }
  
            const otpEl = document.getElementById("OtpModalToggle");
            if (otpEl) {
              const otpModal = new window.bootstrap.Modal(otpEl);
              otpModal.show();
            }
          }, 1000);
        } else {
          toast.error(response.data.message || "Login failed.", { position: "top-right" });
        }
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Login failed. Please try again.", { position: "top-right" });
      } finally {
        setLoading(false);
      }
    };
  
    const handleGoogleSuccess = async (tokenResponse) => {
      try {
        let email = "";
        let google_id = "";
    
        if (tokenResponse?.credential) {
          // From <GoogleLogin /> button
          const decoded = jwtDecode(tokenResponse.credential);
          email = decoded?.email || "";
          google_id = decoded?.sub || "";
        } else if (tokenResponse?.access_token) {
          // From useGoogleLogin() hook
          const userInfo = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
          }).then((res) => res.json());
    
          email = userInfo?.email || "";
          google_id = userInfo?.sub || "";
        }
    
        if (!email || !google_id) {
          toast.error("Google login failed. Missing required info.", {
            position: "top-right",
          });
          return;
        }
    
        // ✅ Always use FormData for same API
        const formData = new FormData();
        formData.append("email", email.trim().toLowerCase());
        formData.append("google_id", google_id);
    
        const response = await APIs.post("user/loginViaOTP", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
    
        if (response.data.status === "success") {
          sessionStorage.setItem("pendingUser", JSON.stringify({ email }));
    
          setToastData({
            title: "Login",
            message: response.data.message,
            type: "success",
            id: Date.now(),
          });
    
          setOtpSource("login");
          setTimeout(() => {
            const loginEl = document.getElementById("LoginModalToggle");
            if (loginEl) {
              const loginModal =
                window.bootstrap.Modal.getInstance(loginEl) ||
                new window.bootstrap.Modal(loginEl);
              loginModal.hide();
            }
    
            const otpEl = document.getElementById("OtpModalToggle");
            if (otpEl) {
              const otpModal = new window.bootstrap.Modal(otpEl);
              otpModal.show();
            }
          }, 1000);
        } else {
          toast.error(response.data.message || "Login failed.", {
            position: "top-right",
          });
        }
      } catch (err) {
        console.error(err);
        toast.error("Google login error. Try again later.", {
          position: "top-right",
        });
      }
    };

    // Initialize the Google login hook
    const loginWithGoogle = useGoogleLogin({
      onSuccess: handleGoogleSuccess,
      onError: () => toast.error("Google Login Failed", { position: "top-right" }),
    });

    // Signup Submit
    const handleSignup = async (e) => {
      e.preventDefault();
      if (!validateSignup()) return;
  
      setMessage("");
  
      try {
        const payload = new FormData();
        payload.append("full_name", formData.full_name);
        payload.append("email", formData.email);
        payload.append("mobile_number", formData.mobile_number);
        payload.append("user_type", formData.user_type);
        payload.append("password", formData.password);
        payload.append("user_register_type", "Normal");
        payload.append("country_id", selectedCode.country_id);
        payload.append("country_code", selectedCode.country_code);
        console.log("user/createUser",payload)

        const response = await APIs.post("user/createUser", payload);
  
        const email = formData.email?.trim().toLowerCase();
      // ✅ Store only email temporarily
      sessionStorage.setItem("pendingUser", JSON.stringify({ email }));

        setToastData({
          title: "Signup",
          message: response.data.message,
          type: "success",
          id: Date.now(),
        });
  
        setOtpSource("signup"); // ✅ important for back button
        setTimeout(() => {
          const signupEl = document.getElementById("signupModalToggle");
          if (signupEl) {
            const signupModal =
              window.bootstrap.Modal.getInstance(signupEl) ||
              new window.bootstrap.Modal(signupEl);
            signupModal.hide();
          }
  
          const otpEl = document.getElementById("OtpModalToggle");
          if (otpEl) {
            const otpModal = new window.bootstrap.Modal(otpEl);
            otpModal.show();
          }
        }, 1000);
      } catch (error) {
        toast.error(error.response?.data?.message || "Signup failed. Try again.", { position: "top-right" });
      }
    };
  
    // OTP Handlers
    const handleChangeOTP = (e, idx) => {
      const val = e.target.value.replace(/[^0-9]/g, "");
      const newOtp = [...otp];
      newOtp[idx] = val ? val[0] : "";
      setOtp(newOtp);
      if (val && idx < 5) {
        inputsRef.current[idx + 1].focus();
      }
    };
  
    const handleBackspace = (e, idx) => {
      if (e.key === "Backspace" && !otp[idx] && idx > 0) {
        inputsRef.current[idx - 1].focus();
      }
    };
  
    const handleOTPSubmit = async (e) => {
      e.preventDefault();
      const otpValue = otp.join("");
      if (otpValue.length !== 6) {
        toast.error("Enter 6-digit OTP", { position: "top-right" });
        return;
      }
  
      const pendingUser = JSON.parse(sessionStorage.getItem("pendingUser"));
      const email = pendingUser?.email;

      if (!email) {
        toast.error("User email not found. Please login again.", { position: "top-right" });
        return;
      }
  
      setLoading(true);
      setMessage("");
      try {
        const response = await APIs.post("user/verifyOTP", { otp: otpValue, email });
        const verifiedUser = response.data.data;
        
              // ✅ Save verified user data
              dispatch(setUserData(verifiedUser));
              sessionStorage.setItem("userData", JSON.stringify(verifiedUser));
              sessionStorage.removeItem("pendingUser");
        
        toast.success("OTP verified successfully!", { position: "top-right" });
        //console.log("OTP Response:", response.data);
  
        setTimeout(() => {
         // window.location.href = "/Step2"; // ✅ full reload
           //navigate("/Step2"); 
           if (otpSource === "forgot") {
              const resetModalEl = document.getElementById("ResetPasswordModalToggle");
              const resetModal = new window.bootstrap.Modal(resetModalEl);
              resetModal.show();
            } else {
              // window.location.href = "/Step2";
              navigate("/Step2");
              handleCloseModal("OtpModalToggle")
            }
        }, 1000);
      } catch (error) {
        toast.error(error.response?.data?.message || "OTP verification failed", { position: "top-right" });
      } finally {
        setLoading(false);
      }
    };
  
    const handleBack = () => {
      const otpModal = document.getElementById("OtpModalToggle");
      if (otpModal) {
        const modal = window.bootstrap.Modal.getInstance(otpModal);
        modal.hide();
      }
  
      if (otpSource === "login") {
        const loginModal = document.getElementById("LoginModalToggle");
        if (loginModal) {
          const modal = new window.bootstrap.Modal(loginModal);
          modal.show();
        }
      }
  
      if (otpSource === "signup") {
        const signupModal = document.getElementById("signupModalToggle");
        if (signupModal) {
          const modal = new window.bootstrap.Modal(signupModal);
          modal.show();
        }
      }
    };
  
    const handleResendOTP = async () => {
      try {
        const savedData = JSON.parse(sessionStorage.getItem("loginFormData"));
        const email = savedData?.email;
  
        if (!email) {
          toast.error("Email not found. Please login again.", { position: "top-right" });
          return;
        }
  
        setLoading(true);
        setMessage("");
  
        const response = await APIs.post("user/resendOTP", { email });
  
        if (response.data.status === "success") {
          toast.success("OTP resent successfully!", { position: "top-right" });
        } else {
          toast.error(response.data.message || "Failed to resend OTP.", { position: "top-right" });
        }
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Failed to resend OTP.", { position: "top-right" });
      } finally {
        setLoading(false);
      }
    };

function initModalSwitcher() {
  const triggers = document.querySelectorAll('[data-bs-toggle="modal"][data-bs-dismiss="modal"]');

  triggers.forEach(trigger => {
    // Avoid duplicate listeners
    trigger.removeEventListener("click", handleModalSwitch);
    trigger.addEventListener("click", handleModalSwitch);
  });
}

/**
 * Handles switching between modals smoothly.
 */
function handleModalSwitch(e) {
  e.preventDefault();
  const trigger = e.currentTarget;
  const targetModalSelector = trigger.getAttribute("data-bs-target");
  const currentModal = trigger.closest(".modal");
  const targetModal = document.querySelector(targetModalSelector);

  if (currentModal && targetModal) {
    const currentModalInstance = bootstrap.Modal.getInstance(currentModal);
    currentModalInstance.hide();

    currentModal.addEventListener("hidden.bs.modal", function onHidden() {
      const newModal = new bootstrap.Modal(targetModal);
      newModal.show();
      currentModal.removeEventListener("hidden.bs.modal", onHidden);
    });
  }
}

// ✅ Initialize once when DOM is ready
document.addEventListener("DOMContentLoaded", initModalSwitcher);
useEffect(() => {
  initModalSwitcher();
}, []);


useEffect(() => {
  const handleShown = () => {
    if (mapInstance) {
      window.google.maps.event.trigger(mapInstance, "resize");
      mapInstance.setCenter(coordinates);
    }
  };

  // Bootstrap 5 event when modal becomes visible
  const modal = document.getElementById("addAddressModalToggle");
  modal?.addEventListener("shown.bs.modal", handleShown);

  return () => {
    modal?.removeEventListener("shown.bs.modal", handleShown);
  };
}, [mapInstance, coordinates]);



const handleAddressSelect = (place) => {
  console.log("Selected address:", place);
  console.log("Lat:", place.lat);
  console.log("Lng:", place.lng);
  setCoordinates({ lat: place.lat, lng: place.lng });
  fetchAddress(place.lat,place.lng)
};

useEffect(() => {
  if (mapRef && pickupLat && dropLat) {
    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend({ lat: pickupLat, lng: pickupLng });
    bounds.extend({ lat: dropLat, lng: dropLng });

    mapRef.fitBounds(bounds, {
      top: 50,
      bottom: 50,
      left: 50,
      right: 50
    });
  }
}, [mapRef, pickupLat, pickupLng, dropLat, dropLng]);

  return (
    <div className="page-wrapper about-us">
      <div className="page-content">
        <section className="step-section-md">
          <div className="container">
            <div className="row">
              {/* Left Section */}
               {/* Left Section */}
              <div className="col-lg-6">
                <div className="shipment-information-new">
                  <div className="step-header">
                    <Link to="/">
                      <img src="/images/logo1.jpg" alt="Logo" className="img-fluid" />
                    </Link>
                    {/* user profile display (optional) */}
                    {userData && Object.keys(userData).length > 0 ? (
                      <div className="align-items-center d-flex gap-1" style={{ marginLeft: 15 }}>
                        <img
                          src={userData.profile_image || "/images/user.png"}
                          alt="Profile"
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                        <span style={{ marginLeft: 8 }}>{userData.full_name || ""}</span>
                      </div>
                    ) : (
                      <a data-bs-toggle="modal" href="#LoginModalToggle">
                        <i className="eagle-base-icon-user"></i> Sign In
                      </a>
                    )}
                  </div>

                  <div className="new-title">
                    <h3>{sessionStorage.getItem("categoryName") || "Important Documents"}</h3>
                    <p>
                      {sessionStorage.getItem("categoryDescription") ||
                        "Rely on us for the swift and secure transport of sensitive, time-critical documents, ensuring confidentiality and timely arrival every time."}
                    </p>
                  </div>

                  <div
                    className="map-responsive"
                    style={{
                      borderRadius: 15,
                      overflow: "hidden",
                      border: "1px solid #c5c1c1",
                      marginTop: 15,
                    }}
                  >
                    {isLoaded ? (
                      <GoogleMap
                      center={mapCenter}
                      mapContainerStyle={mapContainerStyle}
                      zoom={pickupLat && dropLat ? undefined : 12}
                      onLoad={(map) => setMapRef(map)}
                      >
                        {/* Pickup Marker */}
                        {pickupLat && pickupLng && (
                          <Marker
                            position={{ lat: pickupLat, lng: pickupLng }}
                            // label={{
                            //   text: "P",
                            //   color: "#fff",
                            //   fontSize: "14px",
                            //   fontWeight: "bold",
                            // }}
                            icon={{
                              url: "/images/srcmap.png", // or full URL
                              scaledSize: new window.google.maps.Size(30, 40), // resize image
                              anchor: new window.google.maps.Point(20, 40), // bottom center
                            }}
                          />
                        )}

                        {/* Dropoff Marker */}
                        {dropLat && dropLng && (
                          <Marker
                            position={{ lat: dropLat, lng: dropLng }}
                            // label={{
                            //   text: "D",
                            //   color: "#fff",
                            //   fontSize: "14px",
                            //   fontWeight: "bold",
                            // }}
                            icon={{
                              url: "/images/destmap.png", // or full URL
                              scaledSize: new window.google.maps.Size(30, 40), // resize image
                              anchor: new window.google.maps.Point(20, 40), // bottom center
                            }}
                          />
                        )}

                        {/* Dotted Polyline */}
                        {pickupLat && pickupLng && dropLat && dropLng && (
                          <Polyline
                            path={[
                              { lat: pickupLat, lng: pickupLng },
                              { lat: dropLat, lng: dropLng },
                            ]}
                            options={{
                              strokeOpacity: 0,
                              icons: [
                                {
                                  icon: {
                                    path: "M 0,-1 0,1",
                                    strokeOpacity: 1,
                                    scale: 4,
                                  },
                                  offset: "0",
                                  repeat: "20px",
                                },
                              ],
                              strokeColor: "#007bff",
                            }}
                          />
                        )}
                      </GoogleMap>
                    ) : (
                      <div style={{ padding: 20, textAlign: "center" }}>Loading map...</div>
                    )}
                  </div>

                  <div className="form-to-location">
                    {/* Pickup */}
                    <div className="form-location">
                      <div className="icon-ftl">
                        <i className="ti-arrow-up"></i>
                      </div>
                      <div className="flex-1">
                        <label>Pickup</label>
                        <h3>{pickup?.address_type || "Home"}</h3>
                        <span>
                          {pickup
                            ? `${pickup.address}, ${pickup.city}, ${pickup.state}, ${pickup.zip_code}`
                            : "Pickup Address"}
                        </span>
                      </div>
                    </div>

                    {/* Drop-Off */}
                    <div className="to-location">
                      <div className="icon-ftl">
                        <i className="ti-arrow-down"></i>
                      </div>
                      <div className="flex-1">
                        <label>Drop-Off</label>
                        <h3>{dropoff?.address_type || "Office"}</h3>
                        <span>
                          {dropoff
                            ? `${dropoff.address}, ${dropoff.city}, ${dropoff.state}, ${dropoff.zip_code}`
                            : "Drop-Off Address"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Section */}
              <div className="col-lg-6">
                <div className="shipment-details-new">
                  <h3 className="step-count">STEP 2/5</h3>
                  <div className="progress-container">
                    <div className="new-progress active"></div>
                    <div className="new-progress active"></div>
                    <div className="new-progress"></div>
                    <div className="new-progress"></div>
                    <div className="new-progress"></div>
                  </div>

                  <div className="new-title">
                    <h3>Pickup & Drop-Off</h3>
                    <p>Enter your pickup and drop-off addresses</p>
                  </div>

                  {/* Pickup Address Select */}
                  <div className="new-location-wraper">
                    <div className="d-flex justify-content-between align-items-center">
                      <label>Pickup Address</label>
                      <i
                        className="ti-plus stylish-plus-icon"
                        // data-bs-toggle="modal"
                        // data-bs-target="#addAddressModalToggle"
                        title="Add New Address"
                        onClick={() => {
                          if (!userId) {
                            toast.error("User not logged in!");
                            return;
                          }
                          setModalType("pickup")
                          const modal = new bootstrap.Modal(
                            document.getElementById("addAddressModalToggle")
                          );
                          modal.show();
                        }}
                      ></i>
                    </div>
                    <Select
                      classNamePrefix="react-select"
                      isSearchable={false} 
                      options={addresses
                        .filter((a) => a.address_id !== dropoff?.address_id) // ⬅ exclude selected dropoff
                        .map((addr) => ({
                          value: addr.address_id,
                          label: `${addr.address}, ${addr.city}, ${addr.state}`,
                          data: addr,
                        }))}
                      placeholder="Select Pickup Address"
                      value={
                        pickup
                          ? {
                              value: pickup.address_id,
                              label: `${pickup.address}, ${pickup.city}, ${pickup.state}`,
                              data: pickup,
                            }
                          : null
                      }
                      onChange={(selected) => {
                        const addr = addresses.find((a) => a.address_id === selected?.value);
                        if (addr) dispatch(setPickupAddress(addr));
                      }}
                      styles={{
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected
                            ? "#54bf66"
                            : state.isFocused
                            ? "#f1f9f1"
                            : "white",
                          color: state.isSelected ? "white" : "black",
                          cursor: "pointer",
                        }),
                        control: (provided,state) => ({
                          ...provided,
                          borderRadius: "8px",
                          borderColor: state.hasValue ? "#54bf66" : "#ced4da",
                          boxShadow: "none",
                          "&:hover": { borderColor: state.hasValue ? "#45a657" : "#adb5bd" },
                        }),
                      }}
                    />

                  </div>

                  {/* Drop-Off Address Select */}
                  <div className="new-location-wraper">
                    <div className="d-flex justify-content-between align-items-center">
                      <label>Drop-Off Address</label>
                    
                      <i
                        className="ti-plus stylish-plus-icon"
                        // data-bs-toggle="modal"
                        // data-bs-target="#addAddressModalToggle"
                        title="Add New Address"
                        onClick={() => {
                          if (!userId) {
                            toast.error("User not logged in!");
                            return;
                          }
                          setModalType("dropoff")
                          const modal = new bootstrap.Modal(
                            document.getElementById("addAddressModalToggle")
                          );
                          modal.show();
                        }}
                      ></i>

                    </div>
                    <Select
                      classNamePrefix="react-select"
                      isSearchable={false}
                      options={addresses
                        .filter((a) => a.address_id !== pickup?.address_id) // ⬅ exclude selected pickup
                        .map((addr) => ({
                          value: addr.address_id,
                          label: `${addr.address}, ${addr.city}, ${addr.state}`,
                          data: addr,
                        }))}
                      placeholder="Select Drop-Off Address"
                      value={
                        dropoff
                          ? {
                              value: dropoff.address_id,
                              label: `${dropoff.address}, ${dropoff.city}, ${dropoff.state}`,
                              data: dropoff,
                            }
                          : null
                      }
                      onChange={(selected) => {
                        const addr = addresses.find((a) => a.address_id === selected?.value);
                        if (addr) dispatch(setDropoffAddress(addr));
                      }}
                      styles={{
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected
                            ? "#54bf66"
                            : state.isFocused
                            ? "#f1f9f1"
                            : "white",
                          color: state.isSelected ? "white" : "black",
                          cursor: "pointer",
                        }),
                        control: (provided,state) => ({
                          ...provided,
                          borderRadius: "8px",
                          borderColor: state.hasValue ? "#54bf66" : "#ced4da",
                          boxShadow: "none",
                          "&:hover": { borderColor: state.hasValue ? "#45a657" : "#adb5bd" },
                        }),
                      }}
                    />
                  </div>

                  {/* Buttons */}
                  <div className="button-wraper-new">
                    <button
                      type="button"
                      className="btn btn-dark btn-lg"
                      onClick={() => navigate(`/Step1/${sessionStorage.getItem("categoryId") || 0}`)}
                    >
                      Back
                    </button>
                    <button type="button" className="btn btn-success btn-lg flex-1" onClick={handleContinue}>
                      Continue
                    </button>
                  </div>
                </div>
              </div>
              {/* End Right Section */}
            </div>
          </div>
        </section>
      </div>

      {/* Add Address Modal */}
      <div
      className="modal fade commen-popup"
      id="addAddressModalToggle"
      tabIndex="-1"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content">
         
          <div className="modal-body">
            <div className="row">
              {/* Left side — Map */}
              <div className="col-lg-6">
                <div
                  style={{
                    width: "100%",
                    height: "400px",
                    borderRadius: "8px",
                    border: "2px solid #54bf66",
                    position: "relative",
                  }}
                >
                
                    <GoogleMap
                      center={coordinates}
                      zoom={14}
                      key={`${coordinates.lat}-${coordinates.lng}`}
                      mapContainerStyle={{ width: "100%", height: "100%" }}
                      onLoad={handleMapLoad}
                      onDragEnd={() => {
                        if (!mapInstance) return;
                        const center = mapInstance.getCenter();
                        const lat = center.lat();
                        const lng = center.lng();
                        setCoordinates({ lat, lng });
                        fetchAddress(lat, lng); // auto-fills formData
                      }}
                    />
               
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -100%)",
                      fontSize: "30px",
                      zIndex: "10",
                      pointerEvents: "none",
                    }}
                  >
                    📍
                  </div>
                </div>
              </div>

              {/* Right side — Form */}
              <div className="col-lg-6">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>

                <h5 className="modal-title">Add New Address</h5>
                <p>Drag the map to your location or search below.</p>
                <div style={{ position: "static" }}>
  <GoogleAddressAutocomplete key={autoKey} onPlaceSelected={handleAddressSelect} />
</div>
                <form className="signup-form" onSubmit={handleAddressSubmit}>
                  <div className="row">
                    {["address", "landmark", "country", "state", "city", "zip_code"].map((field) => (
                      <div className="col-sm-12 col-md-6 mb-2" key={field}>
                        <input
                          type="text"
                          className={`form-control ${errors[field] ? "is-invalid" : ""}`}
                          placeholder={
                            field.charAt(0).toUpperCase() +
                            field.slice(1) +
                            (["address", "country", "state"].includes(field) ? " *" : "")
                          }
                          name={field}
                          value={formData[field]}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              [e.target.name]: e.target.value,
                            }))
                          }
                          // readOnly={["address", "landmark","country", "state", "city", "zip_code"].includes(field)} // ✅ read-only for map-filled fields
                        />
                        {errors[field] && <small className="text-danger">{errors[field]}</small>}
                      </div>
                    ))}


                    <div className="col-sm-12 mb-2">
                      <select
                        className={`form-control select-control ${
                          errors.address_type ? "is-invalid" : ""
                        }`}
                        name="address_type"
                        value={formData.address_type}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            address_type: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select Address Type</option>
                        <option value="Home">Home</option>
                        <option value="Office">Office</option>
                        <option value="Other">Other</option>
                      </select>
                      {errors.address_type && (
                        <small className="text-danger">{errors.address_type}</small>
                      )}
                    </div>

                    <div className="col-md-12 mb-3">
                      <button
                        type="submit"
                        className="eagle-btn w-100 text-center"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save Address"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              {/* End Right side */}
            </div>
          </div>
        </div>
      </div>
    </div>
      {/* Signup Modal */}
      <div
        className="modal fade commen-popup"
        id="signupModalToggle"
        aria-hidden="true"
        aria-labelledby="signupModalToggleLabel2"
        tabIndex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false" 
      >
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body" style={{ display: 'list-item' }}>
              <div className="row">
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("signupModalToggle")}
                  ></button>
                  <div className="col-md-12 text-center">
                        {message && (
                          <div
                            className={`alert ${
                              message.toLowerCase().includes("success")
                                ? "alert-success bg-success text-white"
                                : "alert-danger bg-danger text-white"
                            }`}
                            role="alert"
                          >
                            {message}
                          </div>
                        )}
                      </div>
                  <h5 className="modal-title">Sign Up</h5>
                  <p>
                    Welcome Back! Let&apos;s get started. Please sign in to access all the amazing services
                  </p>

                  {/* Signup Form */}
                  <form className="signup-form" onSubmit={handleSignup}>
                    <div className="row">
                      <div className="col-sm-12 mb-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="User Name *"
                          name="full_name"
                          value={formData.full_name}
                          onChange={handleChange}
                        />
                        {errors.full_name && <small className="text-danger">{errors.full_name}</small>}
                      </div>

                      <div className="col-sm-12 mb-2">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Your Email *"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && <small className="text-danger">{errors.email}</small>}
                      </div>

                      <div className="col-sm-12 mb-6">
                        <div className="input-group d-flex gap-2">
                          <div className="flex-shrink-0">
                            {/* Country Code Dropdown */}
                            <select
                              value={selectedCode ? String(selectedCode.country_id) : ""}
                              onChange={(e) => {
                                const selectedId = Number(e.target.value);

                                const country = countryList.find(
                                  (c) => c.country_id === selectedId
                                );

                                setSelectedCode(country);
                                console.log("Selected country:", country);
                              }}
                              style={{
                                color: "black",
                                background: "white",
                                border: "1px solid #ced4da",    // small gray border
                                borderRadius: "4px",         // optional: slightly rounded corners
                                outline: "none",             // removes focus outline
                                boxShadow: "none",           // remove any shadow
                                padding: "2px 4px 0px 10px",          // compact padding
                                fontSize: "0.85rem",         // slightly smaller text
                                appearance: "none",          // remove default arrow styling in some browsers
                                WebkitAppearance: "none",
                                MozAppearance: "none",
                                marginRight: "10px",
                              }}
                            >
                              {/* placeholder */}
                              <option value="" hidden>
                                Code
                              </option>

                              {countryList.map((c) => (
                                <option key={c.country_id} value={String(c.country_id)}>
                                  {c.country_name} {c.country_code}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="flex-grow-1">
                            {/* Mobile Number */}
                            <input
                              type="tel"
                              className="form-control"
                              placeholder="Your mobile number *"
                              name="mobile_number"
                              value={formData.mobile_number}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        {errors.mobile_number && (
                          <small className="text-danger">{errors.mobile_number}</small>
                        )}
                      </div>

                      <div className="col-sm-12 mb-2">
                        <select
                          className="form-control select-control"
                          name="user_type"
                          value={formData.user_type}
                          onChange={handleChange}
                        >
                          <option value="">User Type</option>
                          <option value="Individual">Individual Customer</option>
                          <option value="Corporate">Corporate</option>
                        </select>
                        {errors.user_type && <small className="text-danger">{errors.user_type}</small>}
                      </div>

                      <div className="col-sm-12 mb-2">
                        <input
                          type={showPassword.password ? "text" : "password"}
                          className="form-control"
                          placeholder="Your Password *"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        <span
                            className="position-absolute"
                            style={{
                              cursor: "pointer",
                              top: "74%",
                              right: "595px",
                              transform: "translateY(-50%)",
                            }}
                            onClick={() =>
                              setShowPassword({
                                ...showPassword,
                                password: !showPassword.password,
                              })
                            }
                          >
                            <i
                              className={`${
                                showPassword.password ? "bi bi-eye-slash" : "bi bi-eye"
                              }`}
                            ></i>
                          </span>
                        {errors.password && <small className="text-danger">{errors.password}</small>}
                      </div>

                      <div className="col-md-12 mb-3">
                        <button type="submit" className="eagle-btn w-100 text-center">
                          <span className="eagle-button-text">Signup</span>
                          <span className="eagle-button-icon-wrapper">
                            <span className="eagle-button-icon">
                              <i className="eagle-base-icon-black-arrow-1"></i>
                            </span>
                          </span>
                        </button>
                      </div>

                      

                      <div className="col-md-12 col-lg-12">
                        Already have an account?{" "}
                        <a
                          href="javascript:void(0)"
                          data-bs-target="#LoginModalToggle"
                          data-bs-toggle="modal"
                          data-bs-dismiss="modal"
                        >
                          Login Now!
                        </a>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="col-lg-6">
                  <img src="/images/banner-slider-img/1.jpg" className="img-fluid" alt="Signup" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    { /* End */}
    {/* Model  */}
          {/* Login Modal */}
            <div
            className="modal fade commen-popup"
            id="LoginModalToggle"
            aria-hidden="true"
            aria-labelledby="LoginModalToggleLabel"
            tabIndex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false" 
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body" style={{ display: 'list-item' }}>
                  <div className="row">
                    <div className="col-lg-6">
                      <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("LoginModalToggle")}
                  ></button>
                      {message && (
                          <div
                            className={`alert ${
                              message.toLowerCase().includes("success")
                                ? "alert-success bg-success text-white"
                                : "alert-danger bg-danger text-white"
                            }`}
                            role="alert"
                          >
                            {message}
                          </div>
                        )}
                      <h5 className="modal-title" id="LoginModalToggleLabel">
                        Login
                      </h5>
                      <p>
                        Welcome Back! Let's get started. Please sign in to access all
                        the amazing services
                      </p>

                      <form
                        className="Login-form"
                        onSubmit={handleSubmit}
                        noValidate
                      >
                        <div className="row">
                          <div className="col-sm-12 mb-2">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Email *"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                            />
                            {errors.email && (
                              <small className="text-danger">{errors.email}</small>
                            )}
                          </div>

                          <div className="col-sm-12 mb-2">
                            <input
                              type={showPassword.password ? "text" : "password"}
                              className="form-control"
                              placeholder="Password *"
                              name="password"
                              value={formData.password}
                              onChange={handleChange}
                            />
                            <span
                              className="position-absolute"
                              style={{
                                cursor: "pointer",
                                top: "44%",
                                right: "426px",
                              }}
                              onClick={() =>
                                setShowPassword({
                                  ...showPassword,
                                  password: !showPassword.password,
                                })
                              }
                            >
                             <i
                              className={`bi ${
                                showPassword.password ? "bi-eye-slash-fill" : "bi-eye-fill"
                              }`}
                              style={{ fontSize: "1.2rem", color: "#555" }}
                            ></i>
                            </span>
                            {errors.password && (
                              <small className="text-danger">{errors.password}</small>
                            )}
                            <a
                              href="#"
                              data-bs-target="#ForgotPasswordModalToggle"
                              data-bs-toggle="modal"
                              className="float-end mt-1"
                            >
                              <small>Forgot Password?</small>
                            </a>
                          </div>

                          <div className="col-md-12 mb-3">
                            <button
                              type="submit"
                              className="eagle-btn text-center w-100"
                              disabled={loading}
                            >
                              <span className="eagle-button-text">
                                {loading ? "Logging in..." : "Login"}
                              </span>
                              <span className="eagle-button-icon-wrapper">
                                <span className="eagle-button-icon">
                                  <i className="eagle-base-icon-black-arrow-1"></i>
                                </span>
                              </span>
                            </button>
                          </div>

                          <div className="col-md-12 mb-3">
                            <button
                              type="button"
                              className="loginwith-google text-center eagle-btn w-100"
                              onClick={() => loginWithGoogle()}
                            >
                              <img
                                src="/images/google.svg"
                                className="img-fluid"
                                alt="google"
                              />
                              <span className="eagle-button-text">Login with Google</span>
                            </button>
                          </div>

                          <div className="col-md-12 col-lg-12">
                            Don't have an account?{" "}
                            <a
                              href="javascript:void(0)"
                              data-bs-target="#signupModalToggle"
                              data-bs-toggle="modal"
                              data-bs-dismiss="modal"
                            >
                              Sign Up Now!
                            </a>
                          </div>

                        
                        </div>
                      </form>
                    </div>

                    <div className="col-lg-6">
                      <img
                        src="/images/banner-slider-img/1.jpg"
                        className="img-fluid"
                        alt="banner"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
     
          {/* End Login Model  */}
          <div
            className="modal fade commen-popup"
            id="OtpModalToggle"
            aria-hidden="true"
            aria-labelledby="OtpModalToggleLabel"
            tabIndex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false" 
            >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body" style={{ display: 'list-item' }}>
                  <div className="row">
                    <div className="col-lg-6">
                      <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("OtpModalToggle")}
                  ></button>
                      {message && (
                          <div
                            className={`alert ${
                              message.toLowerCase().includes("success")
                                ? "alert-success bg-success text-white"
                                : "alert-danger bg-danger text-white"
                            }`}
                            role="alert"
                          >
                            {message}
                          </div>
                        )}
                      <h5 className="mt-2">Enter OTP</h5>
                      <p>Please check your emails, including the spam folder, for the one time password we sent you.</p>

                      <form onSubmit={handleOTPSubmit}>
                        <div className="d-flex gap-2 mb-3">
                          {otp.map((digit, idx) => (
                            <input
                              key={idx}
                              type="text"
                              className="form-control text-center"
                              maxLength={1}
                              value={digit}
                              onChange={(e) => handleChangeOTP(e, idx)}
                              onKeyDown={(e) => handleBackspace(e, idx)}
                              ref={(el) => (inputsRef.current[idx] = el)}
                            />
                          ))}
                        </div>

                        <div className="col-md-12 gap-2 mb-3 d-flex">
                          <button
                            type="button"
                            className="eagle-btn text-center w-50"
                            onClick={handleBack}
                          >
                            BACK
                          </button>
                          <button
                            type="submit"
                            className="eagle-btn text-center w-50"
                            disabled={loading}
                          >
                            {loading ? "Verifying..." : "VERIFY"}
                          </button>
                        </div>
                        <div className="mb-2">
                          Didn't receive an OTP?{" "}
                          <button
                              type="button"
                              className="btn btn-link p-0"
                              onClick={handleResendOTP}
                              disabled={loading}
                          >
                              {loading ? "Resending..." : "Resend"}
                          </button>
                          </div>

                      </form>
                    </div>

                    <div className="col-lg-6">
                      <img
                        src="/images/banner-slider-img/1.jpg"
                        className="img-fluid"
                        alt="banner"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           {/* Forgot Password Modal */}
          <div
            className="modal fade commen-popup"
            id="ForgotPasswordModalToggle"
            aria-hidden="true"
            aria-labelledby="ForgotPasswordModalToggleLabel"
            tabIndex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body" style={{ display: "list-item" }}>
                  <div className="row">
                    <div className="col-lg-6">
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => handleCloseModal("ForgotPasswordModalToggle")}
                      ></button>

                      <h5 className="modal-title" id="ForgotPasswordModalToggleLabel">
                        Forgot Password
                      </h5>
                      <p>
                        Enter your email id and we'll send you instructions to reset your password
                      </p>

                      <form
                        className="Login-form"
                        onSubmit={handleForgotPasswordSubmit}
                        noValidate
                      >
                        <div className="row">
                          <div className="col-sm-12 mb-2">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Email *"
                              name="forgotEmail"
                              value={forgotEmail}
                              onChange={(e) => setForgotEmail(e.target.value)}
                            />
                          </div>

                          <div className="col-md-12 mb-3 d-flex justify-content-between">
                            <button
                              type="button"
                              className="eagle-btn text-center w-50 me-2"
                              data-bs-target="#LoginModalToggle"
                              data-bs-toggle="modal"
                              data-bs-dismiss="modal"
                            >
                              BACK
                            </button>
                            <button
                              type="submit"
                              className="eagle-btn text-center w-50"
                              disabled={loadingForgot}
                            >
                              <span className="eagle-button-text">
                                {loadingForgot ? "Sending..." : "Send OTP"}
                              </span>
                              <span className="eagle-button-icon-wrapper">
                                <span className="eagle-button-icon">
                                  <i className="eagle-base-icon-black-arrow-1"></i>
                                </span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>

                    <div className="col-lg-6">
                      <img
                        src="/images/banner-slider-img/1.jpg"
                        className="img-fluid"
                        alt="Forgot Password"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* RESET PASSWORD MODAL */}
                <div
            className="modal fade commen-popup"
            id="ResetPasswordModalToggle"
            tabIndex="-1"
            aria-hidden="true"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => handleCloseModal("ResetPasswordModalToggle")}
                      ></button>

                      <h5 className="modal-title">Reset Password</h5>
                      <p>Enter your new password below</p>

                      <form onSubmit={handleResetPassword}>
                        <div className="mb-2 position-relative">
                          <input
                            type={showPassword.password ? "text" : "password"}
                            className="form-control"
                            placeholder="New Password"
                            value={resetPassword.password}
                            onChange={(e) =>
                              setResetPassword({ ...resetPassword, password: e.target.value })
                            }
                          />
                          <span
                            className="position-absolute"
                            style={{
                              cursor: "pointer",
                              top: "50%",
                              right: "15px",
                              transform: "translateY(-50%)",
                            }}
                            onClick={() =>
                              setShowPassword({
                                ...showPassword,
                                password: !showPassword.password,
                              })
                            }
                          >
                            <i
                              className={`${
                                showPassword.password ? "bi bi-eye-slash" : "bi bi-eye"
                              }`}
                            ></i>
                          </span>
                          {resetErrors.password && (
                            <small className="text-danger">{resetErrors.password}</small>
                          )}
                        </div>

                        <div className="mb-2 position-relative">
                          <input
                            type={showPassword.confirmPassword ? "text" : "password"}
                            className="form-control"
                            placeholder="Confirm Password"
                            value={resetPassword.confirmPassword}
                            onChange={(e) =>
                              setResetPassword({
                                ...resetPassword,
                                confirmPassword: e.target.value,
                              })
                            }
                          />
                          <span
                            className="position-absolute"
                            style={{
                              cursor: "pointer",
                              top: "50%",
                              right: "15px",
                              transform: "translateY(-50%)",
                            }}
                            onClick={() =>
                              setShowPassword({
                                ...showPassword,
                                confirmPassword: !showPassword.confirmPassword,
                              })
                            }
                          >
                            <i
                              className={`${
                                showPassword.confirmPassword ? "bi bi-eye-slash" : "bi bi-eye"
                              }`}
                            ></i>
                          </span>
                          {resetErrors.confirmPassword && (
                            <small className="text-danger">{resetErrors.confirmPassword}</small>
                          )}
                        </div>

                        <button type="submit" className="eagle-btn w-100" disabled={loadingReset}>
                          {loadingReset ? "Resetting..." : "Reset Password"}
                        </button>
                      </form>

                    </div>

                    <div className="col-lg-6">
                      <img
                        src="/images/banner-slider-img/1.jpg"
                        className="img-fluid"
                        alt="Reset Password"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

    </div>
  );
};

export default Step2;